import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheck, Headphones, ArrowRight } from 'lucide-react';
import { CONTACT_PATH } from '@/config/site';

const Support24hSection = () => {
  return (
    <section className="w-full bg-white py-20 md:py-32 overflow-hidden font-inter relative">
      {/* Background Subtle Accent */}
      <div className="absolute top-1/2 left-0 w-[300px] h-[300px] bg-purple-50 rounded-full blur-[100px] opacity-40 -z-10" />

      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 md:gap-32 items-center">
          
          {/* Lado Esquerdo: Imagem Minimalista */}
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="relative order-2 lg:order-1"
          >
            <div className="relative group overflow-hidden rounded-[40px] border border-slate-100 shadow-[0_32px_64px_-16px_rgba(0,0,0,0.05)] transition-all duration-700 hover:shadow-[0_48px_80px_-24px_rgba(127,0,255,0.1)]">
              <img 
                src="/lukos_support_corporate.png" 
                alt="Suporte Premium Lukos" 
                className="w-full h-[450px] md:h-[600px] object-cover transition-transform duration-1000 group-hover:scale-105" 
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f172a]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
            </div>
          </motion.div>

          {/* Lado Direito: Conteúdo de Texto Editorial */}
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="flex flex-col gap-10 order-1 lg:order-2"
          >
            <div className="flex flex-col gap-5">
              <div className="flex items-center gap-3">
                <div className="w-8 h-[2px] bg-[#7f00ff] rounded-full" />
                <span className="text-[#7f00ff] font-bold text-sm uppercase tracking-[0.25em]">Suporte Especializado</span>
              </div>
              <h2 className="text-[40px] md:text-[56px] font-extrabold text-[#0f172a] leading-[1.02] tracking-[-0.05em] font-outfit">
                Suporte Especializado <br />
                <span className="text-[#7f00ff]">disponível 24/7</span>
              </h2>
            </div>

            <p className="text-[19px] text-slate-500 leading-relaxed max-w-xl font-medium">
              Tenha acesso direto a um time de especialistas sêniores. Na Lukos, o suporte não é apenas técnico, é consultivo — focado em manter sua operação fluida e sem interrupções.
            </p>

            {/* Benefícios em Grid Refinado */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-2">
              <div className="flex items-start gap-5 group">
                <div className="w-14 h-14 shrink-0 rounded-2xl bg-purple-50 flex items-center justify-center text-[#7f00ff] transition-all duration-300 group-hover:bg-[#7f00ff] group-hover:text-white">
                  <ShieldCheck size={28} strokeWidth={1.5} />
                </div>
                <div className="flex flex-col gap-1">
                  <h4 className="font-bold text-[#0f172a] text-lg font-outfit">Garantia de SLA</h4>
                  <p className="text-[15px] text-slate-500 leading-snug">Compromisso real com a resolução imediata do seu problema.</p>
                </div>
              </div>

              <div className="flex items-start gap-5 group">
                <div className="w-14 h-14 shrink-0 rounded-2xl bg-purple-50 flex items-center justify-center text-[#7f00ff] transition-all duration-300 group-hover:bg-[#7f00ff] group-hover:text-white">
                  <Headphones size={28} strokeWidth={1.5} />
                </div>
                <div className="flex flex-col gap-1">
                  <h4 className="font-bold text-[#0f172a] text-lg font-outfit">Suporte de Elite</h4>
                  <p className="text-[15px] text-slate-500 leading-snug">Atendimento multicanal via WhatsApp, Chat e Telefone.</p>
                </div>
              </div>
            </div>

            <div className="pt-4">
              <Link to={CONTACT_PATH} className="group inline-flex items-center gap-4 bg-[#7f00ff] text-white px-8 md:px-12 py-5 rounded-full text-lg font-bold transition-all hover:bg-[#6b00d7] hover:shadow-[0_20px_40px_rgba(127,0,255,0.3)] active:scale-95">
                Falar com especialista agora
                <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors">
                  <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
                </div>
              </Link>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Support24hSection;

